import Badge from 'components/Badge';
import { CellWrapper } from './styled';

interface Props {
    value?: string;
}

type BadgeVariant = 'warning' | 'success' | 'error' | 'default' | 'inverse' | 'lightest' | 'outline-brand' | 'brand';

const statusMap: Record<string, { label: string; variant: BadgeVariant }> = {
    pending: { label: 'Pending', variant: 'warning' },
    scheduled: { label: 'Scheduled', variant: 'default' },
    due: { label: 'Due', variant: 'warning' },
    completed: { label: 'Completed', variant: 'success' },
    cancelled: { label: 'Cancelled', variant: 'error' },
};

const StatusColumn = ({ value = 'pending' }: Props) => {
    const status = statusMap[value] || { label: value || 'Unknown', variant: 'default' as BadgeVariant };

    return (
        <CellWrapper>
            <Badge
                variant={status.variant}
                borderRadius="semi-square"
                label={status.label}
            />
        </CellWrapper>
    );
};

export default StatusColumn;
